/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_113_TitleInputs */

const en_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`White Calla Lily`)
};

const ar_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زهرة كالا ليلي`)
};

const de_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiße Calla-Lilie`)
};

const es_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lirio de Calas Blanco`)
};

const fr_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lys Calla blanc`)
};

const it_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calla Bianca`)
};

const ja_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホワイトカラーリリー`)
};

const ko_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`화이트 칼라 백합`)
};

const pt_br_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lírio Copo de Leite`)
};

const ru_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Белая калла`)
};

const th_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คาลล่าลิลลี่`)
};

const tr_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beyaz Kalla Zambağı`)
};

const zh_cn_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯白海芋`)
};

const zh_tw_tree_type_113_title = /** @type {(inputs: Tree_Type_113_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`純白海芋`)
};

/**
* | output |
* | --- |
* | "White Calla Lily" |
*
* @param {Tree_Type_113_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_113_title = /** @type {((inputs?: Tree_Type_113_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_113_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_113_title(inputs)
	if (locale === "ar") return ar_tree_type_113_title(inputs)
	if (locale === "de") return de_tree_type_113_title(inputs)
	if (locale === "es") return es_tree_type_113_title(inputs)
	if (locale === "fr") return fr_tree_type_113_title(inputs)
	if (locale === "it") return it_tree_type_113_title(inputs)
	if (locale === "ja") return ja_tree_type_113_title(inputs)
	if (locale === "ko") return ko_tree_type_113_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_113_title(inputs)
	if (locale === "ru") return ru_tree_type_113_title(inputs)
	if (locale === "th") return th_tree_type_113_title(inputs)
	if (locale === "tr") return tr_tree_type_113_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_113_title(inputs)
	return zh_tw_tree_type_113_title(inputs)
});